import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBRecurringExportSourceInput } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  source: DBRecurringExportSourceInput;
};

type Response = {
  formatted: string;
};

export const validateRecurringExportTimeFormat = async (
  scope: RequestScope,
  { source }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<Response>>(
      '/recurring_export_time_format_check',
      {
        type: source.type,
        host: source.host,
        port: source.port,
        username: source.username,
        ...(source.password !== undefined && { password: source.password }),
        frequency: source.frequency,
        file_template: source.fileTemplate,
        ...(source.dateTimeTemplateVar !== undefined && { date_time_template_var: source.dateTimeTemplateVar }),
      },
      { ...options, _sessionSemanticRead: true }
    );

    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e, { redactRequestData: true });
  }
};
